export default __webpack_public_path__ + "static/media/titre.82093912.png";